import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import SubMenuItem from "./SubMenuItem.js";
import { GlassConstants } from "../../utils/GlassConstants.js";

export default function GlassContextMenu({ menuId, title, items, contextMenu, onClose, isMerged = false })
{
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const titleOffset = title ? 1 : 0;

    return (
        <Menu
            open={contextMenu !== null}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
            disableAutoFocus
            disableRestoreFocus
            disableEnforceFocus
            className="glass-context-menu"
            slotProps={GlassConstants.slotProps(hoveredIndex, titleOffset)}
            onClick={(e) => e.stopPropagation()}
            disableAutoFocusItem
        >
            { title && ( <div style={GlassConstants.titleStyle}> {title} </div> )}
            {items.map((item, index) =>
            {
                if(item.subMenu)
                {
                    return (
                        <SubMenuItem
                            key={item.action || index}
                            item={item}
                            index={index}
                            hoveredIndex={hoveredIndex}
                            setHoveredIndex={setHoveredIndex}
                            parentMenuId={menuId}
                        />
                    );
                }
                else if(item.notification)
                {
                    return (
                        <div className={item.className ?? ""}>
                            {item.label}
                        </div>
                    );
                }
                else
                {
                    return (
                        <MenuItem
                            key={item.action || index}
                            onClick={() => { item.onClick?.(); onClose(); }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            sx={GlassConstants.sx(hoveredIndex, index)}
                        >
                            {item.label}
                        </MenuItem>
                    );
                }
            })}
        </Menu>
    );
}